import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations'
import i18nConfig from 'utils/i18nConfig'
import Layout from 'components/layout/Layout'
import { DEFAULT_NAMESPACES } from 'constants/i18n'
import { Language } from 'types/language'
import BoltFix from 'features/bolt-fix/BoltFix'
import type { BoltFixProps } from 'features/bolt-fix/types'
import type { SeoProps } from 'components/seo/types'
import { log } from 'utils/logging'
import { cmsLib } from 'lib'
import { PRODUCTS } from '@boltenergy-be/shared'
import { useTranslation } from 'next-i18next/pages'
import { mapCmsEncyclopediaArticlesToArticles } from 'utils/cms'

const BoltFixPage = (props: BoltFixProps) => {
  // i18n
  const { t } = useTranslation('boltFix')

  // Constants
  const seo: SeoProps = {
    title: t('seo.title'),
    description: t('seo.description'),
    image: props?.seo?.metaImage?.url
  }

  return (
    <Layout {...{ seo }}>
      <BoltFix {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const data = await cmsLib.getProductPage(PRODUCTS.fix, locale === Language.FRENCH ? Language.FRENCH : Language.DUTCH)

  if (!data) {
    log({ error: 'No content found for bolt-fix landingspage', identifier: '[CMS:boltFix:getStaticProps]' })

    return {
      notFound: true,
      revalidate: 5
    }
  }

  const { seo, encyclopedia_articles, ...content } = data

  const articles = encyclopedia_articles?.length ? mapCmsEncyclopediaArticlesToArticles(encyclopedia_articles) : []

  return {
    props: {
      content,
      articles,
      seo,
      ...(await serverSideTranslations(locale, [...DEFAULT_NAMESPACES, 'simulation', 'generator', 'pricing', 'boltFix'], i18nConfig))
    }
  }
}

export default BoltFixPage
